import React, { useRef } from "react";
import Contact from "../../components/contact";
import Footer from "../../components/footer";
import Hero from "../../components/hero";
import Navbar from "../../components/Navbar";
import Projects from "../../components/projects";
import AppWrapper from "../../components/app/AppWrapper";
import { LocomotiveScrollProvider } from "react-locomotive-scroll";
import { useHomepageQuery } from "../../../infrastructure/hooks/useHomepageQuery";

const Home = (): JSX.Element => {
  const containerRef = useRef(null);

  const { data, isFetching, isLoading } = useHomepageQuery();

  return (
    <LocomotiveScrollProvider
      options={{
        smooth: true,
        multiplier: 1.5,
        class: "is-reveal",
        offset: [0, 0],
        repeat: true,
        lerp: 0.2,
      }}
      containerRef={containerRef}
    >
      <main data-scroll-container ref={containerRef}>
        {isFetching || isLoading ? (
          <div>Loading...</div>
        ) : (
          <AppWrapper>
            <Navbar />
            <Hero introduction={data!.introduction} />
            <Projects projects={data!.projects} />
            <Contact />
            <div data-scroll-section>
              <Footer />
            </div>
          </AppWrapper>
        )}
      </main>
    </LocomotiveScrollProvider>
  );
};

export default React.memo(Home);
